// extracted by mini-css-extract-plugin
export var closeButton = "_jq-1";
export var closeX = "_jq-3";
export var container = "_jq-0";
export var image = "_jq-2";